import React from 'react';
import { RoleAiMarketplace } from '@/components/ai/RoleAiMarketplace';

/**
 * Guardian AI Tools Marketplace
 * Guardians (parents) have 2 AI tool slots to customize their experience
 */
export default function GuardianAiMarketplace() {
  return (
    <div className="mx-auto max-w-5xl">
      <RoleAiMarketplace
        role="guardian"
        title="AI Tools Marketplace"
        description="Browse and activate AI tools to help you stay connected with your child's education. Choose up to 2 tools."
      />
    </div>
  );
}
